var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',[_vm._v("\n\t\tHow to Find & Assign Article-A-Day"),_c('sup',[_c('small',[_vm._v("TM")])]),_vm._v(" Sets\n\t")]),_vm._v(" "),_c('p',[_c('iframe',{attrs:{"src":"https://player.vimeo.com/video/196881392","width":"640","height":"360","frameborder":"0","webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}})])])
}]

export { render, staticRenderFns }